import { curry } from 'ramda';

export const padZeros = curry(function (length, val) {
    val = val.toString();

    while (val.length < length) {
        val = '0' + val;
    }

    return val;
});

export const pad2Zeros = padZeros(2);

// 2023-11-01 - trimStart and trimEnd moved from util.js

export const trimStart = (value, character) => {
    if (typeof value !== 'string') {
        return null;
    }

    if (typeof character !== 'string') {
        throw new Error('Cannot trim value, invalid character: ' + character);
    }

    var index = 0;
    while (value[index] === character) {
        index += 1;
    }

    return value.substr(index);
};

export const trimEnd = (value, character) => {
    if (typeof value !== 'string') {
        return null;
    }

    if (typeof character !== 'string') {
        throw new Error('Cannot trim value, invalid character: ' + character);
    }

    var index = value.length;
    while (value[index - 1] === character) {
        index -= 1;
    }

    return value.substr(0, index);
};
